/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import { PARENT_EMAIL_ROUTES } from '../../util/vars';
import React from 'react';
import ParentEmailSignUp from './pages/ParentEmailSignUp/ParentEmailSignUp';
import ParentEmailConsent from './pages/ParentEmailSignUp/ParentEmailConsent';
import ParentEmailUnsubscribe from './pages/unsubscribe/ParentEmailUnsubscribe';

export default function Routes() {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route path={`${path}${PARENT_EMAIL_ROUTES.signup}`}>
        <ParentEmailSignUp />
      </Route>
      <Route path={`${path}${PARENT_EMAIL_ROUTES.consent}`}>
        <ParentEmailConsent />
      </Route>
      <Route path={`${path}${PARENT_EMAIL_ROUTES.unsubscribe}`}>
        <ParentEmailUnsubscribe />
      </Route>
    </Switch>
  );
}
